$(() => {
    function markReady(link) {
      link.classList.add('ready');
    }

    Array.from(document.querySelectorAll('.image-loading')).forEach(link => {
      let img = link.querySelector('img');

      if (img.complete) {
        markReady(link);
    } else {
        img.addEventListener('load', () => markReady(link));
      }
    });
});
